import { WebPlugin } from '@capacitor/core';
export class ZendeskSupportWeb extends WebPlugin {
    async initialize(options) {
        return new Promise((resolve, reject) => {
            const scriptUrl = `https://static.zdassets.com/ekr/snippet.js?key=${options.webClientId}`;
            const node = document.createElement('script');
            node.src = scriptUrl;
            node.type = 'text/javascript';
            node.async = true;
            node.id = 'ze-snippet';
            document.getElementsByTagName('head')[0].appendChild(node);
            node.addEventListener('load', () => {
                const bodyNode = document.querySelector('body');
                if (bodyNode) {
                    try {
                        waitForAddedNode({
                            parent: bodyNode,
                            selector: 'iframe[data-product="web_widget"]',
                            recursive: false,
                            done: function (el) {
                                // @ts-ignore
                                window.zE('messenger:set', 'zIndex', -999);
                                new MutationObserver(function (mutationsList) {
                                    for (let mutation of mutationsList) {
                                        if (mutation.type === 'childList' &&
                                            mutation.target === document.body &&
                                            mutation.previousSibling === el) {
                                            const chatWrapper = mutation.addedNodes[0];
                                            if (chatWrapper && chatWrapper.tagName === 'DIV') {
                                                const buttonElement = (chatWrapper).querySelectorAll('iframe')[0];
                                                // @ts-ignore
                                                this.disconnect();
                                                if (buttonElement) {
                                                    resolve();
                                                    observeChatButton(buttonElement);
                                                }
                                            }
                                        }
                                    }
                                }).observe(document, {
                                    childList: true,
                                    subtree: true,
                                });
                            },
                        });
                    }
                    catch (e) {
                        reject(e);
                    }
                }
            });
        });
    }
    async setAnonymousIdentity(options) {
        console.log('setAnonymousIdentity not implemented on web yet!', options);
    }
    async setIdentity(option) {
        window.zE('messenger', 'loginUser', function (callback) {
            callback(option.token);
        });
    }
    async openChat() {
        try {
            window.zE('messenger', 'open');
            window.zE('messenger:set', 'zIndex', 999);
        }
        catch (error) {
            console.log(error);
        }
    }
    async closeChat() {
        window.zE('messenger', 'close');
        window.zE('messenger:set', 'zIndex', -999);
    }
}
function waitForAddedNode(params) {
    new MutationObserver(function () {
        const el = document.querySelector(params.selector);
        if (el) {
            // @ts-ignore
            this.disconnect();
            params.done(el);
        }
    }).observe(params.parent || document, {
        subtree: !!params.recursive || !params.parent,
        childList: true,
    });
}
function observeChatButton(buttonElement) {
    new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' &&
                mutation.attributeName === 'style' &&
                mutation.oldValue) {
                if (!mutation.oldValue.includes('display: none')) {
                    // @ts-ignore
                    window.zE('messenger:set', 'zIndex', -999);
                }
            }
        }
    }).observe(buttonElement, {
        attributes: true,
        attributeOldValue: true,
    });
}
//# sourceMappingURL=web.js.map